import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import {NavParamService} from './repository/navparams';
import {AuthService} from './repository/auth.service';
import {ScopeProgramService} from './repository/scope.program.service';
import {StorageProvider} from './repository/storage';
import {IonicStorageModule} from '@ionic/storage';
import {HttpClientModule} from '@angular/common/http';
import {ModalAssessmentLandingPage} from "./pages/program/modal-assessment-landing/modal-assessment-landing.page";

@NgModule({
  declarations: [AppComponent,ModalAssessmentLandingPage],
  entryComponents: [ModalAssessmentLandingPage],
  imports: [
    BrowserModule,
    IonicModule.forRoot(),
    IonicStorageModule.forRoot(),
    AppRoutingModule,
    HttpClientModule,
  ],
  providers: [
    StatusBar,
    SplashScreen,
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
      NavParamService,
      AuthService,
      ScopeProgramService,
      StorageProvider
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
